import React, { useState, useRef, useEffect } from "react";
import Search2 from "../img/Search2.svg";

const SideMenu = () => {
  const [openItem, setOpenItem] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const sidebarRef = useRef(null);

  const toggleDropdown = (item) => {
    setOpenItem(openItem === item ? null : item);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setSidebarOpen(false);
      }
    };

    if (sidebarOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  const menuItems = [
    // {
    //   name: "Apps",
    //   subItems: [
    //     { name: "App 1", url: "https://example.com/app1" },
    //     { name: "App 2", url: "https://example.com/app2" },
    //   ],
    // },
    {
      name: "Mobile Apps",
      subItems: [
        {
          name: "iOS",
          url: "https://apps.apple.com/in/developer/gks-infotech-private-limited/id1751898817",
        },
        {
          name: "Android",
          url: "https://play.google.com/store/apps/developer?id=GKS+Infotech+Pvt+Ltd.",
        },
      ],
    },
  ];

  return (
    <div>
      <div className="w-full hidden sm:block lg:w-56 p-4 rounded  bg-white">
        {/* Search Section */}
        {/* <div className="w-full relative">
        <img
          src={Search2}
          alt="search icon"
          className="absolute top-2 left-1"
        />
        <input
          type="text"
          placeholder="Search"
          className="w-full h-8 pl-7 rounded-md"
          style={{ border: "1px solid #4E495833" }}
        />
      </div> */}

        <ul className="space-y-2">
          {menuItems.map((item) => (
            <li key={item.name}>
              <div
                className="cursor-pointer flex justify-between items-center bg-white p-2 rounded hover:bg-gray-200"
                onClick={() => toggleDropdown(item.name)}
              >
                <span className="font-semibold text-xl">{item.name}</span>
              </div>
              {openItem === item.name && (
                <ul className="pl-4 mt-1 space-y-1   text-sm text-gray-700">
                  {item.subItems.map((sub, idx) => (
                    <li
                      key={idx}
                      onClick={() =>
                        window.open(sub.url, "_blank", "noopener,noreferrer")
                      }
                      className="hover:underline cursor-pointer text-sm text-gray-700"
                    >
                      {sub.name}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
      <div className="md:hidden flex justify-between items-center px-4 py-3 bg-white shadow">
        <button
          onClick={() => setSidebarOpen(true)}
          className="text-3xl"
          aria-label="Open sidebar"
        >
          &#9776;
        </button>
      </div>

      <div
        ref={sidebarRef}
        className={`fixed top-0 left-0 h-full w-1/2 bg-white shadow z-50 py-4 overflow-y-auto transition-all duration-500 ease-in-out ${
          sidebarOpen
            ? "translate-x-0 opacity-100"
            : "-translate-x-full opacity-0"
        }`}
      >
        <div className="flex justify-between px-4 items-center mb-4">
          <h2 className="text-lg font-semibold">Menu</h2>
          <span
            onClick={() => setSidebarOpen(false)}
            className="text-2xl font-bold"
          >
            &times;
          </span>
        </div>
        <div className="w-full border-1 border"></div>

        <ul className="space-y-2 mt-2 px-2 ">
          {menuItems.map((item) => (
            <li key={item.name}>
              <div
                className="cursor-pointer flex justify-between items-center bg-white p-2 rounded hover:bg-gray-200"
                onClick={() => toggleDropdown(item.name)}
              >
                <span className="font-semibold text-xl">{item.name}</span>
              </div>
              {openItem === item.name && (
                <ul className="pl-4 mt-1 space-y-1 text-sm text-gray-700">
                  {item.subItems.map((sub, idx) => (
                    <li
                      key={idx}
                      onClick={() =>
                        window.open(sub.url, "_blank", "noopener,noreferrer")
                      }
                      className="hover:underline cursor-pointer"
                    >
                      {sub.name}
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default SideMenu;
